import Styles from './form-status-styles.scss';
import { CircleSpinner } from '@/presentation/components';
import React from 'react';
const FormStatus = ({ state }) => {
    const { isLoading, mainError } = state;
    return (React.createElement("div", { "data-testid": "error-wrap", className: Styles.errorWrap },
        isLoading && React.createElement(CircleSpinner, null),
        mainError && (React.createElement("span", { "data-testid": "main-error", className: Styles.error }, mainError))));
};
export default FormStatus;
